<template>
    <router-view ></router-view>
</template>

<script>
export default {
    name: "BuilderRouter",
}
</script>

<style scoped>

.container {
    margin-top: 8px;
    overflow: visible;
}
</style>